import React, { Component } from 'react';
import './Menu.css';
import Selection from './Selection/Selection.js';
class Menu extends Component {
  render() {
    return (
        <div className="menu">
          <Selection link="home" mainState={this.props.mainState}
            clickSelection={(curr)=>this.props.changeSelection(curr)}/>

          <Selection link="projects" mainState={this.props.mainState}
            clickSelection={(curr)=>this.props.changeSelection(curr)} />

          <Selection link="woodwork" mainState={this.props.mainState}
            clickSelection={(curr)=>this.props.changeSelection(curr)} />

          <Selection link="about"  mainState={this.props.mainState}
            clickSelection={(curr)=>this.props.changeSelection(curr)} />
        </div>
    );
  }
}

export default Menu;



// WEBPACK FOOTER //
// ./src/Menu/Menu.js